import { render, staticRenderFns } from "./ProductFooBestDetail.vue?vue&type=template&id=30c4b5f4&scoped=true&"
import script from "./ProductFooBestDetail.vue?vue&type=script&lang=js&"
export * from "./ProductFooBestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductFooBestDetail.vue?vue&type=style&index=0&id=30c4b5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4b5f4",
  null
  
)

export default component.exports